<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TlbsMusicPlayer',
  
})
</script>
<template>
  <div
    :class="['tlbs-music-player', (isPlaying ? 'rotate' : '')]"
    @click="switchMusicPlayingStatus"
  >
    <TlbsImage
      style="width: 100%; height: 100%"
      :src="isPlaying ? playStatusIcon : pauseStatusIcon"
      :fit="fit"
      draggable="false"
    />
    <audio
      ref="audio"
      :autoplay="autoplay"
      :loop="loop"
      :src="src"
      @pause="onPause"
      @play="onPlay"
    />
  </div>
</template>

<script setup lang="ts" name="TlbsMusicPlayer">
import TlbsImage from '../image';

interface Props {
  src: string;
  autoplay: boolean;
  loop: boolean;
  playStatusIcon: string;
  pauseStatusIcon: string;
  fit: 'fill' | 'contain' | 'cover' | 'none' | 'scale-down';
}
interface PlayStatusType {
  status: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  src: '',
  autoplay: true,
  loop: true,
  playStatusIcon: 'https://mapapi.qq.com/web/jsapi/assets/play.png',
  pauseStatusIcon: 'https://mapapi.qq.com/web/jsapi/assets/pause.png',
  fit: 'fill',
});

const emit = defineEmits<(e: 'onPlayStatus', playStatus: PlayStatusType) => void>();

// 音乐播放状态
const isPlaying = ref(false);
const audio = ref<HTMLAudioElement | null>(null);
const onPlay = (): void => {
  isPlaying.value = true;
  emit('onPlayStatus', { status: isPlaying.value });
};
const onPause = (): void => {
  isPlaying.value = false;
  emit('onPlayStatus', { status: isPlaying.value });
};
// 切换音乐播放状态
const switchMusicPlayingStatus = (): void => {
  if (!audio.value || !props.src) return;
  isPlaying.value ? audio.value.pause() : audio.value.play();
};

</script>
